export const CustomerServiceEndpoints = {
  UpdateRegistrationDetails: `/UniversalPracticeRegistration/UpdateRegistrationDetails`,
  CommitRegistrationDetails: `/UniversalPracticeRegistration/CommitRegistrationDetails`,
};

export const SubscriptionServiceEndpoints = {
  GetB2BPartner: '/B2BPartners/GetB2BPartners'
}